// Utils
import useParazol from '../services/parazol/useParazol';

/**
 * Wrapper component to protect a feature in the JSX.
 * @param {object} props - The props of the component.
 * @param {Array<string>} props.permissions - The permissions required to access the feature.
 * @param {React.ReactElement} props.children - The children of the component.
 * @returns {React.ReactElement|null}
 */
function ProtectedFeature({ permissions, children }) {
  // Hooks
  const { hasPermission } = useParazol();

  return hasPermission(permissions) ? children : null;
}

export default ProtectedFeature;
